import React, { useContext, useState } from 'react';
import { Menu, MenuItem, USER_THEMES } from '@estendio/presentpal-ui-kit';
import { AiFillCopy } from 'react-icons/ai';
import { MdDeleteForever } from 'react-icons/md';
import { RepositoryContext } from '../../context/RepositoriesContext';
import useNavigation from '../../hooks/navigationHook';
import { Routes } from '../routing/types';
import { DeleteModal } from '../shared/DeleteModal';
import { getFinalTitleValue } from '../../helpers/InputHelper';

export interface EditDeckMenuProps {
  deckId: string;
  deckTitle: string | undefined;
}
export default function EditDeckMenu({
  deckId,
  deckTitle = '',
}: EditDeckMenuProps) {
  const theme = USER_THEMES.PRIMARY;
  const navigateTo = useNavigation();

  const { deckRepository } = useContext(RepositoryContext);

  const [isDeleteDeckModalOpen, setIsDeleteDeckModalOpen] = useState(false);
  const openDeleteDeckModal = () => {
    setIsDeleteDeckModalOpen(true);
  };
  const closeDeleteDeckModal = () => {
    setIsDeleteDeckModalOpen(false);
  };
  const navigateToDeckList = () => {
    navigateTo(Routes.DeckList, undefined);
  };
  const handleDeckDelete = () => {
    if (!deckId) {
      navigateToDeckList();
    }
    // the deck list sends the delete before it fetches, and the store keeps an
    // unsent delete over an older server copy, so the deck can't come back as
    // "-recovered" (PPN-3582)
    deckRepository.deleteDeck(deckId).then(navigateToDeckList);
  };

  const [processing, setProcessing] = useState(false);
  const handleDeckDuplication = async () => {
    if (processing) return;
    setProcessing(true);
    const prefix = 'Copy of ';
    const newTitle = prefix + getFinalTitleValue(deckTitle);
    const duplicatedDeck = await deckRepository.duplicateDeck(deckId, newTitle);
    navigateTo(Routes.EditDeck, {
      deckId: duplicatedDeck.id,
      duplicated: true,
    });
    //Prevents users from creating multiple duplicates on vigorous clicking
    setTimeout(() => {
      setProcessing(false);
    }, 1000);
  };
  return (
    <>
      <Menu theme={theme} buttonIconSize="xl">
        <MenuItem
          icon={
            <span className="rotate-180">
              <AiFillCopy />
            </span>
          }
          theme={theme}
          text="Duplicate deck"
          role="button"
          onClick={handleDeckDuplication}
        />
        <MenuItem
          icon={<MdDeleteForever />}
          theme={theme}
          text="Delete deck"
          role="button"
          onClick={openDeleteDeckModal}
        />
      </Menu>
      <DeleteModal
        type="deck"
        isDeleteModalOpen={isDeleteDeckModalOpen}
        handleDelete={handleDeckDelete}
        closeDeleteModal={closeDeleteDeckModal}
      />
    </>
  );
}
